<template>
  <div>
    <resource
      resource="user"
      :original="user"
      :staticMode="isDeleted"
      :attributes="[
        {
          name: 'id',
          label: 'ID',
          disabled: true
        },
        {
          name: 'name',
          label: 'Name'
        },
        {
          name: 'email',
          label: 'Email'
        },
        {
          name: 'password',
          label: 'Password'
        },
        {
          name: 'roles',
          label: 'Rollen',
          type: 'RoleSelector'
        },
        {
          name: 'permissions',
          label: 'Berechtigungen',
          type: 'PermissionSelector'
        }
      ]"
    >
      <template v-slot:title>
        <h4>
          Systembenutzer Bearbeiten
          <span v-if="isDeleted" class="badge badge-deleted ml-3"
            >gelöscht</span
          >
          <span v-if="isDeletion" class="badge badge-deletion ml-3"
            >in löschfrist</span
          >
          <span v-if="isDisabled" class="badge badge-disabled ml-3"
            >gesperrt</span
          >
        </h4>
        <p v-if="isDeleted">Gelöscht am: {{ deleted_at }}</p>
        <p v-if="isDeletion">
          Löschfrist seit: {{ deletion_start_at }}
          <br />
          Bereits in Löschfrist: {{ deletion_time }}
          <br />
          Löschfrist Ende: {{ deletion_end_at }}
        </p>
        <p v-if="isDisabled">
          Gesperrt am: {{ disabled_at }}
          <br />
          Grund: {{ user.disabled_message }}
        </p>
      </template>
    </resource>
  </div>
</template>

<script>
import store from "@/store";
import {
  getDateTimeHtml,
  getDateTimeHtmlAddMinutes,
  getTimeDifference
} from "@/js/date";

export default {
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("user/read", [
        {
          name: "where",
          attributes: {
            id: [Number(to.params.id)]
          }
        },
        {
          name: "with",
          value: ["roles", "permissions"]
        }
      ])
      .then(() => {
        next();
      });
  },
  computed: {
    deleted_at() {
      return getDateTimeHtml(this.user.deleted_at);
    },
    disabled_at() {
      return getDateTimeHtml(this.user.disabled_at);
    },
    deletion_start_at() {
      return getDateTimeHtml(this.user.deletion_at);
    },
    deletion_time() {
      return getTimeDifference(this.user.deletion_at);
    },
    deletion_end_at() {
      return getDateTimeHtmlAddMinutes(
        this.user.deletion_at,
        Laravel.settings.deletion_time
      );
    },
    id() {
      return Number(this.$route.params.id);
    },
    user() {
      let user = { ...this.$store.getters["user/find"](this.id) };
      user.roles = user.roles.map(role => role.name);
      return user;
    },
    isDeleted() {
      return this.user.deleted_at !== null;
    },
    isDisabled() {
      return this.user.disabled_at !== null;
    },
    isDeletion() {
      return this.user.deletion_at !== null;
    }
  }
};
</script>

<style></style>
